import React, {useState} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import Select from '../../../shared/Select'
import {useNavigate} from 'react-router-dom'
import _ from 'lodash'

const SelectVariantsModal = ({isOpen, onClose, catalogProduct = {}, product, variantId, isRemapFlow = false}) => {
    const navigate = useNavigate()
    const [selectedOptions, setSelectedOptions] = useState({})
    const [formValid, setFormValid] = useState(false)
    const {attributes = [], thumbnail_link, title, sku} = catalogProduct
    attributes.forEach((attr) => {
        if (!selectedOptions[attr.value_type]) {
            selectedOptions[attr.value_type] = null
        }
        attr.values.forEach((val) => {
            val.label = val.name
            if (attr.value_type === 'color') {
                val.color = val.color_code || val.value
            }
        })
    })

    const handleDesign = () => {
        const findVariant = catalogProduct.variants.find((v) => {
            let match = true;
            v.options.forEach(option => {
                if (option.value !== selectedOptions[option.attribute_type].value) {
                    match = false;
                }
            })
            return match
        })
        let recentlyViewedProducts = JSON.parse(sessionStorage.getItem('recentlyViewedProducts') || '[]')
        // const isAlreadyViewed = recentlyViewedProducts.find(item => item._id === catalogProduct._id)
        recentlyViewedProducts.unshift(catalogProduct)
        recentlyViewedProducts = _.uniqBy(recentlyViewedProducts, '_id')
        if (recentlyViewedProducts.length > 5) {
            recentlyViewedProducts.pop()
        }
        sessionStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProducts))
        // if (!isAlreadyViewed) {
            
        // }
        const remapQuery = isRemapFlow ? '&isRemapFlow=true' : ''
        navigate(`/${catalogProduct._id}?mappingProductId=${product._id}&sku=${findVariant.sku}&variantId=${variantId}${remapQuery}`);
    }

    const handleCancel = () => {
        setFormValid(false)
        setSelectedOptions({})
        onClose()
    }

    const onSelectOption = (type, option) => {
        const selected = {...selectedOptions}
        selected[type] = option
        setSelectedOptions(selected)
        _checkFormValid(selected)
    }

    const _checkFormValid = (selected) => {
        let valid = true
        Object.values(selected).forEach((attr) => {
            if (!attr) {
                valid = false
            }
        })
        setFormValid(valid)
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="select-variants-modal" centered size="lg">
            <ModalHeader toggle={onClose} className="select-variants-modal__header">
                Select variants
            </ModalHeader>

            <ModalBody className="select-variants-modal__body">
                <div className="select-variants-modal__content">
                    <div className="select-variants-modal__image">
                        {thumbnail_link ? (
                            <img src={thumbnail_link} alt={title} />
                        ) : (
                            <div className="select-variants-modal__image-placeholder" />
                        )}
                    </div>

                    <div className="select-variants-modal__form">
                        <div className="select-variants-modal__product-info">
                            <h3 className="select-variants-modal__product-name">{title}</h3>
                            {sku && (
                                <div className="select-variants-modal__sku">
                                    <span className="select-variants-modal__sku-label">SKU:</span>
                                    <span className="select-variants-modal__sku-value">{sku}</span>
                                </div>
                            )}
                        </div>

                        <div className="select-variants-modal__fields">
                            {attributes.map((attr, index) => (
                                <div className="select-variants-modal__field" key={index}>
                                    <Select
                                        className="select-variants-modal__select"
                                        value={selectedOptions[attr.value_type]}
                                        onChange={(option) => onSelectOption(attr.value_type, option)}
                                        options={attr.values}
                                        placeholder={`Select ${attr.value_type}`}
                                        isSearchable={false}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </ModalBody>

            <ModalFooter className="select-variants-modal__footer">
                <div className="select-variants-modal__actions">
                    <button
                        type="button"
                        className="select-variants-modal__button select-variants-modal__button--secondary"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="select-variants-modal__button select-variants-modal__button--primary"
                        onClick={() => handleDesign()}
                        disabled={!formValid}
                    >
                        Design
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default SelectVariantsModal


